import React from "react";
import PropTypes from "prop-types";

import Instructions from "./Instructions";
import ImageEditor from "./ImageEditor";
import TextEditor from "./TextEditor";
import CtaButtonActionEditor from "./CtaButtonActionEditor";
import HelperText from "./HelperText";
import SocialLinksEditor from "./SocialLinksEditor";

import { DialogContent, Box } from "@mui/material";

const type = {
  title: 'text',
  description: 'text',
  custom_cta: 'text',
  logo: 'image',
  cover_image: 'image',
};

const Content = ({ name, value, file, socials, customCtaAction, onChange, onImageRemove, onSave }) => {

  return (
    <DialogContent>
      <Box sx={{ mb: 3, mt: 1 }}>
        {(name !== "social_links" && !socials?.length) && (
          <Instructions name={name} />
        )}

        {type[name] === "image" && (
          <ImageEditor
            name={name}
            value={value}
            file={file}
            onChange={onChange}
            onImageRemove={onImageRemove}
          />
        )}

        {type[name] === "text" && (
          <TextEditor name={name} value={value} onChange={onChange} />
        )}

        {name === "custom_cta" && (
          <CtaButtonActionEditor value={customCtaAction} onChange={onChange} />
        )}

        {name === "social_links" && (
          <SocialLinksEditor socials={socials} onSave={onSave} />
        )}

        <HelperText name={name} value={value} />
      </Box>
    </DialogContent>
  );
};

Content.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  customCtaAction: PropTypes.string,
  file: PropTypes.object,
  socials: PropTypes.array,
  onChange: PropTypes.func,
  onImageRemove: PropTypes.func,
  onSave: PropTypes.func,
};

export default Content;
